module.exports = __webpack_public_path__ + "static/banner-keyman@3x-a6c8b08b45df90dcf0392f2426669aa6.png";